import { config } from '@/config';

const DEFAULT_MAXIMUM_INACTIVITY_DURATION_MINS = 60;

const MAXIMUM_INACTIVITY_DURATION_MINS =
    Number(config.MAXIMUM_INACTIVITY_DURATION_MINS) ||
    DEFAULT_MAXIMUM_INACTIVITY_DURATION_MINS;

export const ONE_SECOND_MS = 1000;
export const MAXIMUM_INACTIVITY_DURATION_MS =
    MAXIMUM_INACTIVITY_DURATION_MINS * 60 * 1000;
export const INACTIVITY_DIALOG_DURATION_MS = 1000 * 60 * 2; // 2 minutes
